
import type { PropType } from 'vue'
import type { HeadingLevel } from './types'

import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'Heading',
  props: {
    level: { type: String as PropType<HeadingLevel>, required: true },
  },
  setup(props) {
    const computedAs = computed(() => `h${props.level}`)
    return { computedAs }
  },
})
